<div class="d-flex myside-menu-container">
  <div
    class="nav flex-lg-column nav-pills px-1"
    id="v-pills-tab"
    role="tablist"
    aria-orientation="vertical"
  >
    <button
      (click)="goBack()"
      class="nav-link btn-link"
      type="button"
      role="tab"
    >
      <i class="bx bx-arrow-back fs-5"></i>
    </button>

    <button
      [class]="getClass('list')"
      type="button"
      role="tab"
      [routerLink]="['/uiformlist/' + uiformId]"
    >
      <i
        class="fa fa-list"
        matTooltip="{{ 'Remains.Form_List' | translate }}"
        matTooltipPosition="right"
      ></i>
    </button>

    <button
      [class]="getClass('edit')"
      type="button"
      role="tab"
      [routerLink]="['/uiform/' + uiformId]"
    >
      <i
        class="bi bi-card-heading fs-5 p-0"
        matTooltip="{{ 'Remains.Form' | translate }}"
        matTooltipPosition="right"
      ></i>
    </button>

    <button
      [class]="getClass('chart')"
      data-bs-toggle="pill"
      type="button"
      role="tab"
      [routerLink]="['/uiformchart/' + uiformId]"
    >
      <i
        class="fas fa-chart-pie"
        matTooltip="{{ 'Remains.Quick_Chart' | translate }}"
        matTooltipPosition="right"
      ></i>
    </button>

    <button
      [class]="getClass('pivot')"
      data-bs-toggle="pill"
      type="button"
      role="tab"
      [routerLink]="['/uiformpivot/' + uiformId]"
    >
      <i
        class="fadeIn animated bx bx-table bx-sm-1"
        matTooltip="{{ 'Remains.Report' | translate }}"
        matTooltipPosition="right"
      ></i>
    </button>

    <button
      [class]="getClass('info')"
      type="button"
      role="tab"
      [routerLink]="['/uiforminfo/' + uiformId]"
    >
      <i
        class="fa fa-info-circle"
        aria-hidden="true"
        matTooltip="{{ 'Remains.Info' | translate }}"
        matTooltipPosition="right"
      ></i>
    </button>

    <button
      [class]="getClass('aireport')"
      type="button"
      role="tab"
      [routerLink]="['/aireport', uiformId]"
    >
      <img
        [src]="getAiIcon('aireport')"
        alt="AI"
        width="25"
        matTooltip="{{ 'Remains.AI_Report' | translate }}"
        matTooltipPosition="right"
      />
    </button>
  </div>
</div>